export const GENERATED_CONTENT_FALLBACK_TEST_ID = 'generated-content-fallback';
export const FALLBACK_RELOAD_BTN_TEST_ID = 'reload-button';
export const FALLBACK_GO_BACK_BTN_TEST_ID = 'go-back-button';

export const PAGE_FOOTER_BACK_BTN_TEST_ID = 'page-footer-back-btn';
export const PAGE_FOOTER_COMPLETE_BTN_TEST_ID = 'page-footer-complete-btn';

export const CONFIRMATION_BUTTON_TEST_ID = 'confirmation-button-test-id';
export const DISABLED_MESSAGE_TEST_ID = 'disabled-message-test-id';

export const NAVIGATION_FOOTER_BACK_BTN_TEST_ID = 'navigation-footer-back-btn';
export const NAVIGATION_FOOTER_SAVE_AND_RETURN_BTN_TEST_ID = 'navigation-footer-save-and-return-btn';
export const NAVIGATION_FOOTER_SAVE_AND_CONTINUE_BTN_TEST_ID = 'navigation-footer-save-and-continue-btn';

export const PRODUCT_LINE_TITLE_TEST_ID = 'product-line-title';

export const PRIMARY_ACTION_DROPDOWN_TEST_IDS = {
  MAIN_BUTTON: 'primary-action-dropdown-main-button-test-id',
  CANCEL_BUTTON: 'primary-action-dropdown-cancel-button-test-id',
};
